import ArrayUtils from "../../common/utils/array";

export default class Recommend {
    constructor() {
        this._init();
    }

    _init() {
        this.$book = document.querySelector(".js-pageHeader__recommend__book-sp");
        this.$bookImg = this.$book.querySelector("img");

        this.$book.addEventListener("click", () => {
            window.manabiKansoSP.show(this.datas, this.grade);
        });

        document.querySelector(".js-pageHeader__recommend__title-sp").addEventListener("click", () => {
            window.manabiKansoSP.show(this.datas, this.grade);
        });
    }

    setup(books) {
        this.grade = "";
        this.datas = this._getRandomBook(books);
        this.$bookImg.setAttribute("src", this.datas._bookFile);
    }

    _getRandomBook(books) {
        this.grade = ArrayUtils.shuffleArray(["s1", "s2", "s3", "chu"])[0];
        return ArrayUtils.shuffleArray(books[this.grade])[0];
    }
}
